import { fetchWithAuth } from '../utils/fetchWithAuth';
import * as Sentry from "@sentry/react";

export interface DeleteAttachmentParams {
  issueKey: string;
  attachmentId: string;
}

export const attachmentsApi = {
  deleteAttachment: async ({ issueKey, attachmentId }: DeleteAttachmentParams): Promise<boolean> => {
    try {
      const response = await fetchWithAuth(
        `issues/${encodeURIComponent(issueKey)}/attachments/${encodeURIComponent(attachmentId)}`,
        { method: 'DELETE' }
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Échec de la suppression');
      }

      return true;
    } catch (error: unknown) {
      Sentry.captureException(error, {
        level: 'error',
        tags: {
          error_context: 'delete_attachment',
          operation: 'deleteAttachment',
          issue_key: issueKey
        },
        extra: {
          issueKey,
          attachmentId,
          errorMessage: error instanceof Error ? error.message : String(error)
        }
      });

      throw error;
    }
  }
};
